import Color from 'color';
import QRCode from 'qrcode';

import CancellablePromise from 'modules/CancellablePromise';
import { getCurrentPosition } from 'modules/GPS';
import { checkLocationIsOkinawa } from 'modules/Utils';
import tmpls, { parseHandleBars } from 'modules/HandlebarsTemplates';
import GoogleDirection from 'modules/GoogleDirection';
import fetchBusRoute from './fetchBusRoute';

// state
let CURRENT_PROMISE = null;
let CURRENT_SEARCH_DATA = {};
let CURRENT_ROUTES_RESULT = null;
let GMARKERS = [];
let GPOLYLINES = [];
let GDIRECTIONS = [];

const brContainer = $('.busRouteContainer');
const brTitle = $('.brTitle');
const brList = $('.brList');
const brlLoading = $('.brListLoading');
const brDetail = $('.brDetail');
const brdLoading = $('.brDetailLoading');

const HourTemplate = parseHandleBars(window.resolveLang('{{this}}時間'));
const MinuteTemplate = parseHandleBars(window.resolveLang('{{this}}分'));

// ===================================
// EVENTS
$(document).on('click', '.brToggleDetail', () => {
  brContainer.toggleClass('collapse');
});

$(document).on('click', '.routeSummary', e => {
  showRouteDetail($(e.currentTarget).data('index'));
});

$(document).on('click', '.brdTitle', () => {
  brContainer.removeClass('showRouteDetail');
});

$(document).on('click', '.brCloseRoute', () => {
  brContainer.addClass('hidden');
  cancelPreviousPromise();
  clearRouteDetail();
});

$(document).on('click', '.brRedoBusRoute', () => {
  // if redo route, search route with current time from current location
  const { arriveTo, qrOption } = CURRENT_SEARCH_DATA;
  setBusRoute({
    arriveTo,
    qrOption
  });
});

$(document).on('click', '.searchOkinawaBusRoute', e => {
  e.preventDefault();
  const lat = parseFloat($(e.currentTarget).data('latitude'));
  const lng = parseFloat($(e.currentTarget).data('longitude'));
  const subtitle = $(e.currentTarget).data('title');
  const spot_id = $(e.currentTarget).data('spotid');

  console.log(lat);
  console.log(lng);

  if (!lat || !lng) {
    return alert(
      window.resolveLang(
        'スポットの位置情報が取得できないため、ルート検索失敗しました'
      )
    );
  }

  setBusRoute({
    arriveTo: {
      lat,
      lng,
      subtitle
    },
    qrOption: {
      spot_id
    }
  });
});

$(document).on('click', '.brMarkerSegment', e => {
  const lat = $(e.currentTarget).data('lat');
  const lng = $(e.currentTarget).data('lng');

  window.MainMap.gmap.setCenter({
    lat,
    lng
  });

  if (MobileDevice.DeviceType === 1) {
    brContainer.removeClass('collapse');
  }
});

// =================================
// main
// searchData: {
//   departFrom: { <-- all optional
//     lat: 0,
//     lng: 0,
//     originBusStop: 'departure bus stop',
//     subtitle: 'departure',
//     departure: moment()
//   },
//   arriveTo: { <-- lat lng required
//     lat: 0,
//     lng: 0,
//     subtitle: 'destination'
//   },
//   qrOption: {
//     spot_id: '5daf3242342343',
//     time: 100
//   }
// }
const setBusRoute = async searchData => {
  const {
    departFrom = {},
    arriveTo,
    qrOption = {}
  } = (CURRENT_SEARCH_DATA = searchData);

  initRouteList();

  // ==============================
  // ==============================
  // CLOSE ALL OPEN MODALS
  // check if map is showing
  if (!$('#wallContainer').hasClass('closeControl')) {
    window.closeWall();
  }
  // reset balloon
  if (window.MainMap && window.MainMap.spotBalloonMarker) {
    window.MainMap.spotBalloonMarker.setVisible(false);
  }
  // close modal
  window.closeModal();
  // ==============================
  // ==============================

  // check fixedOriginBusStop
  // // =================
  // // uncomment - to use fixedOriginBusStop
  // if (window.AS.fixedOriginBusStop && !departFrom.originBusStop) {
  //   departFrom = {
  //     originBusStop: window.AS.fixedOriginBusStop
  //   };
  // }
  // // uncomment - to use fixedOriginBusStop
  // // ==================

  try {
    if (!departFrom.originBusStop && (!departFrom.lat || !departFrom.lng)) {
      // get current position, but don't show error if there is no position
      try {
        CURRENT_PROMISE = CancellablePromise(getCurrentPosition);
        const {
          coords: { latitude, longitude }
        } = await CURRENT_PROMISE;

        departFrom.lat = latitude;
        departFrom.lng = longitude;
      } catch ({ message }) {
        console.log(message);
      }
    }

    // if departFrom is not in okinawa, set departFrom to naha airport
    if (
      !checkLocationIsOkinawa(
        parseFloat(departFrom.lat || 0),
        parseFloat(departFrom.lng || 0)
      )
    ) {
      departFrom.lat = 26.206487871883393;
      departFrom.lng = 127.65083241652837;
      departFrom.title = window.resolveLang('那覇空港');
    }

    /**
     * This should be implemented from url param?
     * @type {Array}
     */
    // ===============================
    const skipWalkDic = [
      {
        lat: 26.206487871883393,
        lng: 127.65083241652837
      },
      {
        lat: 26.211239538,
        lng: 127.67666866
      }
    ];

    skipWalkDic.some(({ lat, lng }) => {
      console.log(`${lat} - ${lng}`);
      if (departFrom.lat === lat && departFrom.lng === lng) {
        departFrom.skipWalkingToBusStop = true;
        return true;
      }

      return false;
    });
    // ===============================

    CURRENT_PROMISE = CancellablePromise(fetchBusRoute, {
      departFrom,
      arriveTo
    });
    CURRENT_ROUTES_RESULT = await CURRENT_PROMISE;

    await parseRouteList();

    // show qrCode if not mobile
    if (!MobileDevice.IsMobile && AS.showMapQR) {
      const map = (Gdata.CurrentMap.ori && Gdata.CurrentMap.ori[0]) || null;
      if (!map || !qrOption.spot_id) {
        return;
      }

      const {
        mapsConst,
        archiveConst,
        worm,
        wallType,
        selectedPost,
        brSearch,
        brOrigin,
        brOriginLatlng,
        brTime
      } = window.historyObj.urlEnum;

      const resultDepartFrom = CURRENT_ROUTES_RESULT.departFrom;
      const brSearchParam = `${brSearch}=1`;
      const brOriginParam = resultDepartFrom.originBusStop
        ? `${brOrigin}=${resultDepartFrom.originBusStop}`
        : `${brOriginLatlng}=${resultDepartFrom.lat},${resultDepartFrom.lng}`;
      const brTimeParam = `${brTime}=${resultDepartFrom.departure.valueOf()}`;

      let url = `${AS.mapQRDomain}/${mapsConst}/${archiveConst}/${map._id}/${
        worm.map
      }/${wallType.spotList}?${selectedPost}=${
        qrOption.spot_id
      }&${brSearchParam}&${brOriginParam}&${brTimeParam}`;

      if (window.AS.mapSpecialContents && window.AS.mapSpecialContents.length) {
        url += `&qr=${window.AS.mapSpecialContents[0]}`;
      }

      console.log(`Route QR - ${url}`);

      const base64 = await QRCode.toDataURL(url, {
        margin: 0,
        width: 164
      });

      $('.qrRouteCode').attr('src', base64);
    }
  } catch ({ _cancelled, message }) {
    if (!_cancelled) {
      showError(message);
    }
  }
};

window.MapBusController = {
  checkInitBusRouteFromUrl: ({
    _id: spot_id,
    title: subtitle,
    latitude: lat,
    longitude: lng
  } = {}) => {
    if (
      !window.urlData ||
      !window.urlData.searchDic ||
      !window.urlData.searchDic[window.historyObj.urlEnum.brSearch]
    ) {
      return;
    }

    // if spot is not within okinawa, do not show bus route
    if (!checkLocationIsOkinawa(parseFloat(lat || 0), parseFloat(lng || 0))) {
      return;
    }

    const { brOrigin, brOriginLatlng, brTime } = window.historyObj.urlEnum;
    const departFrom = {};

    if (window.urlData.searchDic[brOrigin]) {
      departFrom.originBusStop = window.urlData.searchDic[brOrigin];
    }
    if (window.urlData.searchDic[brOriginLatlng]) {
      const latlng = window.urlData.searchDic[brOriginLatlng].split(',');
      departFrom.lat = parseFloat(latlng[0]);
      departFrom.lng = parseFloat(latlng[1]);
    }
    if (window.urlData.searchDic[brTime]) {
      departFrom.departure = moment(
        parseInt(window.urlData.searchDic[brTime], 10)
      );
    }

    // url contains brSearch param
    setBusRoute({
      departFrom,
      arriveTo: {
        lat,
        lng,
        subtitle
      },
      qrOption: {
        spot_id
      }
    });
  }
};

const parseRouteList = async () => {
  const { routes, departFrom, arriveTo } = CURRENT_ROUTES_RESULT;

  const fromTitle = departFrom.subtitle || departFrom.short_name;
  const toTitle = arriveTo.subtitle || arriveTo.short_name;
  brTitle.html(`${fromTitle} → ${toTitle}`);

  // to calculate total time - ensure departure and arrival time are set
  for (let j = 0, length2 = routes.length; j < length2; j++) {
    const { route } = routes[j];
    const promises = [];
    const firstWalk = route[1] && route[1].walk;
    const lastWalk = route[route.length - 2] && route[route.length - 2].walk;

    if (firstWalk && firstWalk.adjustDeparture) {
      promises.push(handleWalk(route, 1));
    }
    if (lastWalk && !lastWalk.arrival) {
      promises.push(handleWalk(route, route.length - 2));
    }

    try {
      CURRENT_PROMISE = CancellablePromise.all(promises);
      await CURRENT_PROMISE;
    } catch ({ _cancelled }) {
      if (_cancelled) {
        return;
      }
    }
  }

  // set arrivalText and departureText and total time for route
  routes.forEach(routeObj => {
    const { route } = routeObj;

    // add arrivalText, departureText and duration to marker, walk and route
    route.forEach(obj => {
      const arr = ['marker', 'walk', 'route'];
      arr.forEach(key => {
        const elm = obj[key];
        if (elm) {
          elm.arrivalText = parseHm(elm.arrival);
          elm.departureText = parseHm(elm.departure);
          if (elm.arrival && elm.departure && !elm.duration) {
            elm.duration = getDuration(elm.departure, elm.arrival);
          }

          // set first station
          if (!routeObj.firstStation && key === 'route') {
            routeObj.firstStation = elm;
          }
        }
      });
    });

    const resultDepartFrom = route[0].marker;
    const resultArriveTo = route[route.length - 1].marker;

    // to set Start Icon and Goal Icon
    resultDepartFrom.departFrom = true;
    resultArriveTo.arriveTo = true;

    // calculate time and duration for route
    if (resultDepartFrom) {
      routeObj.departure = resultDepartFrom.departure;
      routeObj.departureText = resultDepartFrom.departureText;
    }
    if (resultArriveTo) {
      routeObj.arrival = resultArriveTo.arrival;
      routeObj.arrivalText = resultArriveTo.arrivalText;
    }
    if (routeObj.departure && routeObj.arrival) {
      routeObj.durationText = getDuration(routeObj.departure, routeObj.arrival);
      routeObj.duration = routeObj.arrival.diff(routeObj.departure, 'minutes');
    }
  });

  CURRENT_ROUTES_RESULT.routes = _.sortBy(routes, ['duration']);
  CURRENT_ROUTES_RESULT.routes.forEach((routeObj, index) => {
    routeObj.id = index + 1;
  });

  brList.append(tmpls.hbtRouteSummary(CURRENT_ROUTES_RESULT.routes));

  setListLoading();

  showRouteDetail(0, true);
};

const showRouteDetail = async (index = 0, noShow) => {
  if (
    !CURRENT_ROUTES_RESULT ||
    !CURRENT_ROUTES_RESULT.routes ||
    !CURRENT_ROUTES_RESULT.routes[index]
  ) {
    return;
  }

  // init
  if (!noShow) {
    brContainer.addClass('showRouteDetail');
  }

  const selectedRoute = $(`.routeSummaryIndex${index}`);
  if (selectedRoute.hasClass('selected')) {
    return;
  }

  cancelPreviousPromise();
  $('.routeSummary').removeClass('selected');
  selectedRoute.addClass('selected');
  brDetail.html('');
  setDetailLoading(true);
  clearRouteDetail();

  const routeData = CURRENT_ROUTES_RESULT.routes[index];
  const { route: routeObj } = routeData;

  // check all walk has google direction
  const promises = [];
  for (let j = 0, length2 = routeObj.length; j < length2; j++) {
    const { walk } = routeObj[j];
    if (walk && !walk.directionServiceResult) {
      promises.push(handleWalk(routeObj, j));
    }
  }
  try {
    CURRENT_PROMISE = CancellablePromise(promises);
    await CURRENT_PROMISE;
  } catch ({ _cancelled }) {
    if (_cancelled) {
      return;
    }
  }

  // render detail modal template
  brDetail.append(tmpls.hbtRouteDetail(routeData));

  // draw on map
  const map = window.MainMap.gmap;
  routeObj.forEach(({ marker, walk, route }) => {
    if (marker) {
      const { departFrom, arriveTo, title, lat, lng } = marker;
      let icon;
      if (departFrom) {
        icon = ICONS.departFrom;
      } else if (arriveTo) {
        icon = ICONS.arriveTo;
      } else {
        icon = ICONS.station;
      }

      GMARKERS.push(
        new google.maps.Marker({
          title,
          position: {
            lat,
            lng
          },
          map,
          clickable: false,
          icon
        })
      );
    } else if (walk) {
      const { origin, destination, directionServiceResult: directions } = walk;

      // render walking directions
      if (directions) {
        // has google direction
        GDIRECTIONS.push(
          new google.maps.DirectionsRenderer({
            map,
            suppressMarkers: true,
            preserveViewport: true,
            polylineOptions: DOTTED_POLYLINE,
            directions
          })
        );
      } else {
        // no google direction - render straignt polyline
        GPOLYLINES.push(
          new google.maps.Polyline({
            map,
            path: [origin, destination],
            // geodesic: true,
            ...DOTTED_POLYLINE
          })
        );
      }
    } else if (route) {
      // render polylines
      const { polyline: path, color = '#ced300' } = route;

      GPOLYLINES.push(
        new google.maps.Polyline({
          map,
          path,
          // geodesic: true,
          strokeColor: Color(color)
            .darken(0.35)
            .hex(),
          strokeOpacity: 1,
          strokeWeight: 10
        })
      );

      GPOLYLINES.push(
        new google.maps.Polyline({
          map,
          path,
          strokeColor: color,
          strokeOpacity: 1,
          strokeWeight: 6
          // geodesic: true
        })
      );
    }
  });

  showFullRoute(
    MobileDevice.DeviceType !== 1 && { left: 450, top: 40, right: 50 }
  );

  setDetailLoading();
};

// =================================
// helpers
const cancelPreviousPromise = () => {
  if (CURRENT_PROMISE && CURRENT_PROMISE._cancel) {
    CURRENT_PROMISE._cancel();
  }
};

const initRouteList = () => {
  cancelPreviousPromise();

  brTitle.html('');
  brTitle.parent().removeClass('error');
  brContainer.removeClass('showRouteDetail');
  brContainer.removeClass('collapse');
  brContainer.removeClass('hidden');
  setListLoading(true);
  brList.html('');
};

const showError = text => {
  brTitle.html(text || window.resolveLang('エラーが発生しました。'));
  brTitle.parent().addClass('error');
  setListLoading();
};

const setListLoading = isLoading => {
  if (isLoading) {
    return brlLoading.show();
  }

  brlLoading.hide();
};

const setDetailLoading = isLoading => {
  if (isLoading) {
    return brdLoading.show();
  }

  brdLoading.hide();
};

const clearRouteDetail = () => {
  GMARKERS.forEach(marker => {
    marker.setMap(null);
  });
  GPOLYLINES.forEach(polyline => {
    polyline.setMap(null);
  });
  GDIRECTIONS.forEach(directionDisplay => {
    directionDisplay.setMap(null);
  });

  GMARKERS = [];
  GPOLYLINES = [];
  GDIRECTIONS = [];
};

const getDuration = (from, to) => {
  if (!from || !to) {
    return;
  }

  const diffObj = moment.preciseDiff(from.seconds(0), to.seconds(0), true);
  let duration = '';

  const hours = diffObj.firstDateWasLater
    ? parseInt(from.diff(to, 'hours', true), 10)
    : parseInt(to.diff(from, 'hours', true), 10);

  if (hours) {
    duration += HourTemplate(hours);
  }
  if (diffObj.minutes) {
    duration += MinuteTemplate(diffObj.minutes);
  }

  return duration;
};

const parseHm = date => {
  if (!date) {
    return;
  }

  const {
    departFrom: { departure }
  } = CURRENT_ROUTES_RESULT;

  const day = date.isSame(departure, 'day') ? '' : `(${date.format('dd')})`;

  return `${date.format('HH:mm')}${day}`;
};

const handleWalk = (route, walkIndex) =>
  new Promise(async resolve => {
    try {
      const { walk } = route[walkIndex];
      const departureMarker = route[walkIndex - 1].marker;
      const arrivalMarker = route[walkIndex + 1].marker;

      if (!walk.directionServiceResult) {
        if (!window.MainMap.directionsService) {
          window.MainMap.directionsService = new google.maps.DirectionsService();
        }

        const { origin, destination } = walk;

        const response = await GoogleDirection(
          window.MainMap.directionsService,
          {
            origin,
            destination,
            travelMode: google.maps.TravelMode.WALKING
          }
        ).catch(() => {});

        if (response) {
          walk.directionServiceResult = response;

          const googleDuration = response.routes[0].legs[0].duration.value + 60;

          if (!walk.arrival) {
            walk.arrival = moment(walk.departure).add(googleDuration, 's');
            arrivalMarker.arrival = walk.arrival;
            arrivalMarker.arrivalText = parseHm(walk.arrival);
          } else {
            const currentWalkDuration = walk.arrival.diff(
              walk.departure,
              'seconds',
              true
            );

            if (googleDuration < currentWalkDuration) {
              if (walk.adjustDeparture) {
                // change departure
                walk.departure = moment(walk.arrival).subtract(
                  googleDuration,
                  's'
                );
                departureMarker.departure = walk.departure;
                departureMarker.departureText = parseHm(walk.departure);
              } else {
                // change arrival
                walk.arrival = moment(walk.departure).add(googleDuration, 's');
                arrivalMarker.arrival = walk.arrival;
                arrivalMarker.arrivalText = parseHm(walk.arrival);
              }
            }
          }
        }

        walk.duration = getDuration(walk.departure, walk.arrival);
        walk.departureText = parseHm(walk.departure);
        walk.arrivalText = parseHm(walk.arrival);
      }
    } catch (e) {
      console.log(e);
    }

    resolve();
  });

const showFullRoute = padding => {
  if (!GMARKERS || !window.MainMap || !window.MainMap.gmap) {
    return false;
  }

  const newBounds = new google.maps.LatLngBounds();
  GMARKERS.forEach(marker => {
    newBounds.extend(marker.position);
  });

  window.MainMap.gmap.fitBounds(newBounds, padding);
};

const ICONS = {
  departFrom: '/img/tmp/busRoute/start_icon_blue.png',
  arriveTo: '/img/tmp/busRoute/goal_icon_red.png',
  station: {
    url: '/img/tmp/busRoute/busStopMarker.png',
    scaledSize: {
      width: 24,
      height: 53
    }
  }
};
const DOTTED_POLYLINE = {
  strokeColor: '#2aa2e8',
  strokeOpacity: 0,
  fillOpacity: 0,
  icons: [
    {
      icon: {
        path: 0,
        fillOpacity: 0.7,
        scale: 3
      },
      offset: '0',
      repeat: '10px'
    }
  ]
};

// // ==============================================
// const startSearching = async () => {
//   while (!window.google) {
//     await sleep(300);
//   }

//   setBusRoute({
//     arriveTo: {
//       lat: 35.727272912352156,
//       lng: 139.78831546482706,
//       subtitle: '焼き鳥センター'
//     }
//   });
// };

// const sleep = (interval = 1000, haha) =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//     }, interval);
//   });

// startSearching();
